export const SQUARE_METERS_IN_SQUARE_KILOMETER = 1000000;
